var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4633A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3331 15.6133V28.3867C37.3331 32.0667 34.3464 35.0533 30.6664 35.0533H17.3331C16.7198 35.0533 16.1331 34.9733 15.5598 34.8133C14.7331 34.5867 14.4664 33.5333 15.0798 32.92L29.2531 18.7467C29.5464 18.4533 29.9864 18.3867 30.3998 18.4667C30.8264 18.5467 31.2931 18.4267 31.6264 18.1067L35.0531 14.6667C36.3064 13.4133 37.3331 13.8267 37.3331 15.6133Z",
    fill: "#F4633A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5203 17.8134L13.5603 31.7734C12.9203 32.4134 11.8537 32.2534 11.427 31.4534C10.9337 30.5467 10.667 29.4934 10.667 28.3867V15.6134C10.667 13.8267 11.6937 13.4134 12.947 14.6667L16.387 18.12C16.907 18.6267 17.7603 18.6267 18.2803 18.12L23.0537 13.3334C23.5737 12.8134 24.427 12.8134 24.947 13.3334L27.5337 15.92C28.0403 16.44 28.0403 17.2934 27.5203 17.8134Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVast);
export default __webpack_public_path__ + "static/media/vast.fa61b1e1016fe6634497fff847935b1e.svg";
export { ForwardRef as ReactComponent };